import { cva } from "class-variance-authority";

export const tableVariants = cva("w-full border-collapse", {
  variants: {
    variant: {
      default: "border-separate border-spacing-0",
      bordered: "border-separate border-spacing-0",
      striped: "border-separate border-spacing-0",
    },
    size: {
      small: "text-body-small-medium",
      medium: "text-body-medium-medium",
      large: "text-body-large-medium",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "medium",
  },
});

export const tableHeaderVariants = cva(
  "text-body-medium-regular text-left text-surface-ink-neutral-normal border-b border-surface-outline-neutral-muted",
  {
    variants: {
      size: {
        small: "px-3 py-2 h-[32px]",
        medium: "px-4 py-3 h-[40px]",
        large: "px-6 py-4 h-[48px]",
      },
    },
    defaultVariants: {
      size: "medium",
    },
  }
);

export const tableCellVariants = cva(
  "text-body-medium-regular border-b border-surface-outline-neutral-muted text-surface-ink-neutral-normal transition-colors duration-150",
  {
    variants: {
      size: {
        small: "px-3 py-2 h-[40px]",
        medium: "px-4 py-3 h-[72px]",
        large: "px-6 py-4 h-[56px]",
      },
      state: {
        default: "",
        focus: "",
        // focus:
        //   "outline outline-2 outline-action-outline-primary-default outline-offset-[-2px]",
      },
    },
    defaultVariants: {
      size: "medium",
      state: "default",
    },
  }
);
